import { render, staticRenderFns } from "./imgView.vue?vue&type=template&id=d07b7dea&scoped=true&"
import script from "./imgView.vue?vue&type=script&lang=js&"
export * from "./imgView.vue?vue&type=script&lang=js&"
import style0 from "./imgView.vue?vue&type=style&index=0&id=d07b7dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07b7dea",
  null
  
)

export default component.exports